import { SButton, SDropdownMenu } from '@setvi/shared/components';
import { Customer } from 'Services/MongoRealm/Types';
import { useSnackbar } from 'notistack';
import { useMutation } from '@tanstack/react-query';
import moment from 'moment';
import axios from 'axios';

export interface PriceListerProps {
  accountNumber: Customer['accountNumber'];
}

export const PriceLister = ({ accountNumber }: PriceListerProps) => {
  const { enqueueSnackbar } = useSnackbar();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async (costIncluded: boolean) => {
      const url = new URL(
        `/price-lister/${accountNumber}`,
        process.env.REVOPS_API
      );
      url.searchParams.append('costIncluded', String(costIncluded));

      await axios
        .get(url.toString(), { responseType: 'blob' })
        .then(async response => {
          try {
            const blob = await response?.data;

            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            const date = moment.utc(new Date()).format('MM/DD/YYYY');
            link.setAttribute(
              'download',
              `PriceLister_${accountNumber}_${date}.csv`
            );
            document.body.appendChild(link);
            link.click();
            link.remove();
          } catch (e) {
            enqueueSnackbar('Failed to generate file download.', {
              variant: 'error'
            });
          }
        })
        .catch(error => {
          const errorMessage =
            error.status === 404
              ? 'Price lister is not available for this customer'
              : error.message;

          enqueueSnackbar(errorMessage, {
            variant: 'error'
          });
        });
    }
  });

  return (
    <SDropdownMenu
      newDesign
      menuItems={[
        {
          text: 'With Cost',
          disabled: isLoading,
          onClick: () => mutateAsync(true)
        },
        {
          text: 'Without Cost',
          disabled: isLoading,
          onClick: () => mutateAsync(false)
        }
      ]}>
      <SButton
        loading={isLoading}
        style={{
          borderRadius: 36
        }}>
        Price Lister
      </SButton>
    </SDropdownMenu>
  );
};
